var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',{attrs:{"percentage":_vm.progress,"text-inside":true,"stroke-width":15}})}
var staticRenderFns = []

export { render, staticRenderFns }